import { Operation } from '@apollo/client'

export const isStrapiRequest = (operation: Operation) => {
  const api = operation.getContext().api as 'strapi' | null

  return api === 'strapi'
}

export const apolloStrapiContext = {
  api: 'strapi',
}
